import { useMutation } from 'react-query'
import { getFileAPI } from 'framework/api/http'

interface GetOrdersExportCsvInterface {
  from?: string
  principle?: any
  to?: string
}

export const useGetFileVsOrderExportCSV = () => {
  const mutate = useMutation(
    ({ from, principle, to }: GetOrdersExportCsvInterface) => {
      // BDL20-2286: the endpoint now streams text/csv; request it as a blob so the
      // promise resolves only once the whole file has been received.
      return getFileAPI(
        `/FileVsOrder/CsvList?&Principle=${
          principle?.value === 'All' ? '' : principle?.value
        }&To=${to}&From=${from}`,
      )
    },
  )

  return mutate
}

export default GetOrdersExportCsvInterface
